/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Ki_Feedback_TitleInputs */

const en_register_onboarding_ki_feedback_title = /** @type {(inputs: Register_Onboarding_Ki_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Feedback`)
};

const de_register_onboarding_ki_feedback_title = /** @type {(inputs: Register_Onboarding_Ki_Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Feedback`)
};

/**
* | output |
* | --- |
* | "AI Feedback" |
*
* @param {Register_Onboarding_Ki_Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_ki_feedback_title = /** @type {((inputs?: Register_Onboarding_Ki_Feedback_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Ki_Feedback_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_ki_feedback_title(inputs)
	return en_register_onboarding_ki_feedback_title(inputs)
});